import Agenda from "../classes/Agenda";
import AgribexForm from "../classes/AgribexForm";
import FlickerEmbedHelper from "../classes/FlickerEmbedHelper";
import HamburgerNav from "../classes/HamburgerNav";
import RefreshMeeting from "../classes/RefreshMeeting";
import SwiperHelper from "../classes/SwiperHelper";
import TagFilter from "../classes/TagFilter";
import ZoomBinar from "../classes/ZoomBinar";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

//init application
const initApplication = () => {
  let ajaxBaseUrl = "";
  if (initVals.webRoot && initVals.webRoot != "") {
    ajaxBaseUrl = "/" + initVals.webRoot;
  }

  const hamburger = new HamburgerNav({
    navSelector: ".fullNav",
    navOpenBtn: ".hamburgerNav",
    navCloseBtn: ".hamburgerNav",
  });

  hamburger.init();
  const uitgelichtswiperContainer = document.querySelector(".uitgelichtSwiper");
  if (uitgelichtswiperContainer) {
    const uitgelichtswiper = new SwiperHelper({
      swiperSelector: ".uitgelichtSwiper",
      swiperOptions: {
        loop: true,
        spaceBetween: 8,
        breakpoints:
          uitgelichtswiperContainer.dataset.count > 1
            ? {
                // when window width is >= 320px
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                },
              }
            : {},
      },
    });

    uitgelichtswiper.init();
  }

  const impressiesSwiper = new SwiperHelper({
    swiperSelector: ".impressiesSwiper",
    swiperOptions: {
      loop: true,
      spaceBetween: 8,
    },
  });

  impressiesSwiper.init();

  //news or event card filter
  const newsHolder = document.querySelector("#newsHolder .list");
  if (newsHolder) {
    const newsFilter = new TagFilter({
      searchUrl: "",
      inputSelector: ".newsFilter input",
      resultsSelector: ".newsFilter .results",
      tagsHolderSelector: ".newsFilter .tagsHolder",
      clearSelector: ".newsFilter .clear",
      itemHolderSelector: "newsHolder",
      listSettings: {
        valueNames: ["title", { data: ["category", "author", "date"] }],
      },
      minCharacters: 2,
    });

    newsFilter.init();
  }

  //process form
  const isRequestForm = document.querySelector(".aanvraagForm");

  const confirmForm = new AgribexForm({
    formSelector: isRequestForm ? ".aanvraagForm" : ".bevestigingEvent",
    teamMembersHolderSelector: ".teamMembersHolder",
    removeBtnSelector: ".removeTeamMember",
    invitedInputsHolderSelector: ".invitedInputsHolder",
    addTeamOptions: {
      formHolderSelector: ".teamMemberPanel",
      closeBtnSelector: ".closeTeamMemberPanel",
      openBtnSelector: ".openTeamMemberPanel",
      editTeamMemberSelector: ".editTeamMember",
    },
  });

  confirmForm.init();

  //flickr helper
  const flickrHelper = new FlickerEmbedHelper({
    flickrIframeSelector: ".flickrEmbed",
  });

  flickrHelper.init();

  //agenda
  /* const agenda = new Agenda({
    fetchUrl: ajaxBaseUrl + "/api/agenda-items",
    agendaSelector: ".agenda",
    agendaFilterSelector: ".agendaFilter",
    listSettings: {
      valueNames: ["title", { data: ["category", "author"] }],
    },
    minCharacters: 2,
    agendaTitleSelector: ".agendaHeader h3",
    agendaPrevSelector: ".agendaPrev",
    agendaNextSelector: ".agendaNext",
  });

  agenda.init(); */

  if (zoomSDKSettings) {
    //zoom binar setup
    const zoomBinar = new ZoomBinar({
      zoomSelector: ".zoomElem",
      meetConfig: {
        signatureUrl: ajaxBaseUrl + "/api/get-signature",
        ...zoomSDKSettings,
        role: 0, // 1 for host; 0 for attendee
      },
    });

    zoomBinar.init();
  }

  //refresh meeting
  const refreshMeeting = new RefreshMeeting({
    binarWaitingSelector: ".binarWaiting",
    apiUrl: ajaxBaseUrl + "/api/check-access",
  });

  refreshMeeting.init();

  //tippy
  const tippyUsePhone = document.getElementById("tippyUsePhone");

  if (tippyUsePhone && tippyUsePhone.dataset.info) {
    tippy("#tippyUsePhone", {
      trigger: "mouseenter click",
      hideOnClick: true,
      placement: "top-start",
      content: tippyUsePhone.dataset.info,
    });
  }
};

export default initApplication;
